import React, {Component, Fragment} from 'react';
import ReactDOM from 'react-dom'
import classNames from "classnames";
import './AuthTextarea.scss'
class AutoTextarea extends Component {
  textareaRef = React.createRef();

  constructor(props) {
    super(props);

    this.state = {
      rows: 2,
      minRows: 2,
      maxRows: 50,
      html: this.props.value,
      range: null,
      selection: null,
      colorSelection: null,
      value: this.props.value
    }

    this.pendingValue = this.props.value;
  }

  mouseDownActive = false
  pendingValue = "";

  componentDidMount() {
    this.target = ReactDOM.findDOMNode(this);

    // this.updateTextAreaHeight(target);
    this.handleDocumentMouseUp = this.handleDocumentMouseUp.bind(this)
    this.handlePaste = this.handlePaste.bind(this)
    this.handleSelection = this.handleSelection.bind(this)
    this.handleSelectionChange = this.handleSelectionChange.bind(this)
    this.target.addEventListener("paste", this.handlePaste);
  }

  componentWillUnmount() {
    this.target.removeEventListener('paste', this.handlePaste)
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if(this.props.value !== this.pendingValue) {
      console.log('this.props.value != this.state.value', this.props.value, this.pendingValue)
      this.setState({html: this.props.value})
      this.pendingValue = this.props.value
    }
  }

  handleInput(event, touched) {

    let selection = document.getSelection();
    if(!selection || selection.rangeCount === 0) {
      this.setState({
        range: null,
        selection: null,
        colorSelection: null,
      })
      this.mouseDownActive = false
    } else {
      let range = selection.getRangeAt(0);
      if(range && range.startOffset === range.endOffset) {
        this.setState({
          range: null,
          selection: null,
          colorSelection: null,
        })
        this.mouseDownActive = false
      }
    }


    const value = this.textareaRef.current.innerHTML;
    const innerText = this.textareaRef.current.innerText.replaceAll(" ", "").replace(/(\r\n|\n|\r)/gm, "");
    if(!innerText) {
      this.pendingValue = "";
      this.props.onChange("");
    }
    else {
      this.pendingValue = value;
      this.props.onChange(value);
    }

  }

  handleMouseLeave(e) {
    if(this.mouseDownActive && !this.state.colorSelection) {
      document.removeEventListener('mouseup', this.handleDocumentMouseUp)
      document.addEventListener('mouseup', this.handleDocumentMouseUp)
    }
  }

  handleDocumentMouseUp(e) {
    document.removeEventListener('mouseup', this.handleDocumentMouseUp)
    this.handleSelection(e)
  }

  handlePaste(e) {
    e.preventDefault();
    let text = e.clipboardData.getData("text/plain");
    document.execCommand("insertHTML", false, text);
    // this.handleSelection(e)
  }

  handleSelectionChange(e) {
    // let selection = document.getSelection();
    // if(selection && !this.target.contains(selection.anchorNode)) {
    //   this.setState({
    //     range: null,
    //     selection: null,
    //     colorSelection: null,
    //   })
    //   this.mouseDownActive = false
    //   return;
    // }

    setTimeout(() => {
      let selection = document.getSelection();
      if(!selection || selection.rangeCount === 0) {
        this.setState({
          range: null,
          selection: null,
          colorSelection: null,
        })
        this.mouseDownActive = false
        document.removeEventListener("selectionchange", this.handleSelectionChange);

      } else {
        if(!this.target.contains(selection.anchorNode)) {
          this.setState({
            range: null,
            selection: null,
            colorSelection: null,
          })
          this.mouseDownActive = false
        } else {
          let range = selection.getRangeAt(0);
          if(range && range.startOffset === range.endOffset) {
            this.setState({
              range: null,
              selection: null,
              colorSelection: null,
            })
            this.mouseDownActive = false
          }
        }
        document.removeEventListener("selectionchange", this.handleSelectionChange);
      }
    }, 1000)
  }

  handleSelection(e) {
    if(this.state.colorSelection) {
      let selection = document.getSelection();
      if(selection) {
        let range = selection.getRangeAt(0);
        if(range && range.startOffset !== range.endOffset) {
          // console.log(document.queryCommandState('bold'), document.queryCommandState('italic'), document.queryCommandState('strikeThrough'), document.queryCommandState('underline'))
          this.setState({
            range: range,
            selection: selection,
            colorSelection: {
              x: e.clientX,
              y: e.clientY,
              bold: document.queryCommandState('bold'),
              italic: document.queryCommandState('italic'),
              strikeTrough: document.queryCommandState('strikeTrough'),
              underline: document.queryCommandState('underline'),
            }
          })
          this.mouseDownActive = false;
          document.addEventListener("selectionchange", this.handleSelectionChange);
        } else  if(range && range.startOffset === range.endOffset && this.target.contains(selection.anchorNode)) {
          this.setState({
            range: null,
            selection: null,
            colorSelection: null
          })
          this.mouseDownActive = false;
          document.removeEventListener("selectionchange", this.handleSelectionChange);
        }
        return;
      }
      return;
    }

    let selection = document.getSelection();
    if(!selection) {
      return;
    }
    let range = selection.getRangeAt(0);
    if(range && range.startOffset !== range.endOffset) {
      this.setState({
        range: range,
        selection: selection,
        colorSelection: {
          x: e.clientX,
          y: e.clientY,
          bold: document.queryCommandState('bold'),
          italic: document.queryCommandState('italic'),
          strikeTrough: document.queryCommandState('strikeTrough'),
          underline: document.queryCommandState('underline'),
        }
      })
      this.mouseDownActive = false;
      document.addEventListener("selectionchange", this.handleSelectionChange);
    } else {
      this.setState({
        range: null,
        selection: null,
        colorSelection: null,
      })
      this.mouseDownActive = false;
    }
  }

  applyCommand(e, command, option) {
    e.preventDefault();
    e.stopPropagation();
    document.removeEventListener("selectionchange", this.handleSelectionChange);
    let selection =  document.getSelection() ;
    selection.removeAllRanges();
    // selection.removeAllRanges();
    selection.addRange(this.state.range)
    document.execCommand(command, false, option);
    selection.removeAllRanges();

    this.setState({
      range: null,
      selection: null,
      colorSelection: null
    }, () => {
      this.handleInput()
    })
    this.mouseDownActive = false
  }

  updateTextAreaHeight(target) {
    const textareaLineHeight = 24;
    const {minRows, maxRows} = this.state;

    const previousRows = target.rows;
    target.rows = minRows; // reset number of rows in textarea

    const currentRows = ~~(target.scrollHeight / textareaLineHeight);

    if (currentRows === previousRows) {
      target.rows = currentRows;
    }

    if (currentRows >= maxRows) {
      target.rows = maxRows;
      target.scrollTop = target.scrollHeight;
    }

  	this.setState({
    	rows: currentRows < maxRows ? currentRows : maxRows,
    });
  }

  render() {
    return (
      <Fragment>
        <p
          onMouseUp={(e) => {
            this.handleSelection(e)
          }}
          onMouseDown={(e) => this.mouseDownActive = true}
          onMouseLeave={(e) => this.handleMouseLeave(e)}
          style={{height: 'auto', minHeight: '100px'}}
          contentEditable={true}
          ref={this.textareaRef}
          className={classNames([this.props.className, 'form-control'])}
          // onBlur={event => this.handleInput(event, true)}
          onInput={event => this.handleInput(event)}
          placeholder={this.props.placeholder}
          suppressContentEditableWarning={true}
          dangerouslySetInnerHTML={{__html: this.state.html}}
        />
        {this.state.colorSelection &&
          <div style={{top: this.state.colorSelection.y, left: this.state.colorSelection.x}} className="selection-picker">
            <div className="selection-picker-color-container" onClick={(e) => this.applyCommand(e,"foreColor","#cb0000")}>
              <div style={{background: '#cb0000'}}
                   className="selection-picker-color"></div>
            </div>
            <div className="selection-picker-color-container" onClick={(e) => this.applyCommand(e,"foreColor","#d3c500")}>
              <div style={{background: '#d3c500'}}
                   className="selection-picker-color"></div>
            </div>


            <div className="selection-picker-color-container" onClick={(e) => this.applyCommand(e,"foreColor","#00b005")}>
              <div style={{background: '#00b005'}}
                   className="selection-picker-color"></div>
            </div>


            <div className="selection-picker-color-container" onClick={(e) => this.applyCommand(e,"foreColor","#0067b0")}>
              <div style={{background: '#0067b0'}}
                   className="selection-picker-color"></div>
            </div>

            <div className="selection-picker-color-container" onClick={(e) => this.applyCommand(e,"foreColor","#000000")}>
              <div style={{background: '#000000'}}
                   className="selection-picker-color"></div>
            </div>
            <div className="selection-picker-color-container" onClick={(e) => this.applyCommand(e,"bold")}>
              <div style={{background: this.state.colorSelection.bold? '#000' : '#fff', color: !this.state.colorSelection.bold? '#000' : '#fff'}}
                   className="selection-picker-color">
                <i className="fa fa-bold"></i>
              </div>
            </div>
            <div className="selection-picker-color-container" onClick={(e) => this.applyCommand(e,"italic")}>
              <div style={{background: this.state.colorSelection.italic? '#000' : '#fff', color: !this.state.colorSelection.italic? '#000' : '#fff'}}
                   className="selection-picker-color">
                <i className="fa fa-italic"></i>
              </div>
            </div>
            <div className="selection-picker-color-container" onClick={(e) => this.applyCommand(e,"strikeThrough")}>
              <div style={{background: this.state.colorSelection.strikeTrough? '#000' : '#fff', color: !this.state.colorSelection.strikeTrough? '#000' : '#fff'}}
                   className="selection-picker-color">
                <i className="fa fa-strikethrough"></i>
              </div>
            </div>
            <div className="selection-picker-color-container" onClick={(e) => this.applyCommand(e,"underline")}>
              <div style={{background: this.state.colorSelection.underline? '#000' : '#fff', color: !this.state.colorSelection.underline? '#000' : '#fff'}}
                   className="selection-picker-color">
                <i className="fa fa-underline"></i>
              </div>
            </div>
            <div className="selection-picker-color-container" onClick={(e) => this.applyCommand(e,"undo")}>
              <div style={{background: '#fff'}}
                   className="selection-picker-color">
                <i className="fa fa-undo"></i>
              </div>
            </div>
            <div className="selection-picker-color-container" onClick={(e) =>  this.setState({colorSelection: null})}>
              <div style={{background: '#fff'}}
                   className="selection-picker-color">
                X
              </div>
            </div>
          </div>}
      </Fragment>
    )
  }

}

export default AutoTextarea;
